import { STATUS_VARIANTS } from 'components/Tags/Status/styled';

export const REPORT_PATHS = {
  GATEWAY_INVOICE_DETAILS: 'gateway-invoices/details/reports',
  RECONCILIATION_RESULTS: 'recon/results/report',
  SETTLEMENT_CONTRACT_TRANSACTIONS: 'settlements/contracts/workbook/transactions/report',
  SETTLEMENT_CONTRACT_WORKBOOK: 'settlements/contracts/workbook/report',
} as const;

export enum REPORT_STATE {
  COMPLETED = 'COMPLETED',
  CREATED = 'CREATED',
  FAILED = 'FAILED',
  PROCESSING = 'PROCESSING',
  TIMEOUT = 'TIMEOUT',
}

export const REPORT_STATE_VARIANTS: Record<REPORT_STATE, STATUS_VARIANTS> = {
  [REPORT_STATE.COMPLETED]: STATUS_VARIANTS.SUCCESS,
  [REPORT_STATE.CREATED]: STATUS_VARIANTS.WARNING,
  [REPORT_STATE.FAILED]: STATUS_VARIANTS.ERROR,
  [REPORT_STATE.PROCESSING]: STATUS_VARIANTS.WARNING,
  [REPORT_STATE.TIMEOUT]: STATUS_VARIANTS.ERROR,
};
